import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, from, of, Subject } from 'rxjs';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { AmazonServices } from 'src/app/services/AmazonServices';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import  jsonconf from '../../../../../assets/amazon-xsd/amazon-schemas/TOOLS.json';
import  jsonschema  from '../../../../../assets/amazon-xsd/amazon-schemas/TOOLS.schema.json';
import  jsondefinations  from '../../../../../assets/amazon-xsd/amazon-schemas/DEFINATIONS.json';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import Ajv2019 from "ajv/dist/2019";
//import Ajv from "ajv/dist/2019";
//import Ajv, {JSONSchemaType} from "ajv";
import { addSchema, validate } from "@hyperjump/json-schema/draft-2019-09";
//import Ajv, {JSONSchemaType} from "ajv";
import { P } from '@angular/cdk/keycodes';
import addFormats from "ajv-formats";
import { ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { ImageSelectorComponent } from 'src/app/forms/image-selector/image-selector.component';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { ViewportScroller } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Editor } from 'ngx-editor';
import { ThemeService } from 'src/app/services/theme.service';

export interface Tab{
  description:string,
  title:string,
  tagName:string;
  propertyNames:Properties[];
}


interface ErrorMessagesByTab {
  [tabName: string]: string[];
}

interface ErrorMessageResult {
  message: string;
  tab: string | null; 
}

let errorsByTab: ErrorMessagesByTab = {};

export interface Properties{
    tagName?:string;
    required:boolean|string[];
    $ref?:string;
    title?:string;
    description?:string;
    examples?:string[];
    minItems?: number;
    minUniqueItems?: number;
    maxUniqueItems?: number;
    editable?:boolean;
    hidden?:boolean;
    minLength?:number;
    maxLength?:number;
    enum?:any[];
    enumNames?:string[];
    selectors?:string[];
    type?:string;
    items?:PropertiesItem;
    properties?:Properties;
}

export interface PropertiesItem{
  type:string;
  required:string[];
  properties:Properties;
  additionalProperties:boolean;
}

interface TableColumn {
  columnDef: string;
  header: string;
  type: 'text' | 'number' | 'select';
  options?: { value: string, viewValue: string }[];
  dynamic?:boolean;
  optionsIndex?:any[];
  optionsName?:any[];
}

export interface tab{name:string,title:string,description:string,propertyNames:string[]}

@Component({
    selector: 'amazon-schema-creator',
    templateUrl: './amazon-schema-creator.component.html',
    styleUrls: ['./amazon-schema-creator.component.scss'],
    encapsulation: ViewEncapsulation.None // Desativa a encapsulação de view
    ,
    standalone: false
})
export class AmazonSchemaCreatorComponent implements OnInit {

  constructor(
      public dynaServices:DynamicFormsService, 
      public fb:UntypedFormBuilder,
      public fb2:FormBuilder,
      public http:HTTPService,
      public uas:UserAuthenticationServices,
      private amazonServices:AmazonServices,
      private cd:ChangeDetectorRef,
      private spinnerServices:NgxSpinnerService,
      private sanitizer: DomSanitizer,
      public dialog: MatDialog,
      public ThemeService:ThemeService) { 



        this.formGroup = this.fb2.group({      
          useravatar: new UntypedFormControl('')
        })

        this.formGroupHtml = this.fb2.group({                
        })

      }

  @Input('data') data:GenericEdit;
  @Input()form:UntypedFormGroup;  
  @Input() canConfig:boolean = false;
  @Input('category') category:string = 'tools'.toLowerCase();
  @Input('brownserNodeId') brownserNodeId:string = '';
  @Input('row')row;
  @ViewChild('stepper') stepper: MatStepper;
  @Output()
  selectedTabChange: EventEmitter<MatTabChangeEvent> ;


  jsonConf:Object;
  jsonSchema:Object;// = jsonschema;
  propertyGroups:Object;
  tabsAmazon:Tab[] = [];
  amazonFields:Properties[];
  requiredProperties:string[];
  nonPristine:string[]=[];
  runTimeObject = {};
  missingFields: string[] = [];
  processedRoots = new Set<string>();
  listaDeErros: any[] = []; 
  listaDeErrosDef: any[] = []; 
  erroValidacao = false;
  showFormattedJson: boolean = false;
  jsonValidatorIsCalled: boolean = false;
  formattedJson: string = '';
  currentStepIndex = 0; 
  screenIsReady:boolean = false;
  initialData = [];
  hasVariation:boolean = false;
  compileAjv = new Ajv2019({ allErrors: true, strict: false, discriminator: true  });  
  isComplete:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  tabs:tab[] = [];
  attributes:Object = {};
  prop:{id:string,prop:object}[] = [];
  formGroup:UntypedFormGroup;
  image =  this.sanitizer.bypassSecurityTrustUrl( "assets/image/no-image-icon-round.png");
  codecompany:Number;
  codecontract:Number;
  idUser:any;
  temporaryFiles:any;
  selectedImages:any;
  uploadedImageUrls:any = [];
  prevUploadedImageUrls:any = [];
  codeProduct:any;
  mapTabToScroll = {};
  currentTabIndex = 0;
  additionalConfig:any;

  //RICH
  
  formGroupHtml:UntypedFormGroup;
  parameters:columnsDef[] = [];
  subscribedFieldNames: Set<string> = new Set<string>();


  columns: TableColumn[] = [    
    { columnDef: 'sku', header: 'SKU do vendedor', type: 'text',  dynamic: false },
    {
      columnDef: 'product_identifier_type', header: 'Tipo de identificador único do produto', type: 'select',  dynamic: false,
      options: [
        { value: 'GTIN', viewValue: 'GTIN' },
        { value: 'EAN', viewValue: 'EAN' },
        { value: 'PZN', viewValue: 'PZN' },
        { value: 'GCID', viewValue: 'GCID' },
        { value: 'ASIN', viewValue: 'ASIN' }
      ]
    },
    { columnDef: 'externally_assigned_product_identifier_value', header: 'ID do produto', type: 'text', dynamic: false },    
    {
      columnDef: 'condition_type', header: 'Condição do produto', type: 'select',  dynamic: false,
      options: [{ value: 'Novo', viewValue: 'Novo' }]
    },
    { columnDef: 'price', header: 'Preço padrão', type: 'number' ,  dynamic: false},
    { columnDef: 'quantity', header: 'Quantidade', type: 'number',  dynamic: false }
  ];

  

  displayedColumns: string[] = this.columns.map(c => c.columnDef);
  dataSourceVariation: any[] = []; 
 

   onSelectedTabChange (tabChange) {
    setTimeout(() => {           
      const element = document.querySelector('.mat-step-label-selected');      
      if (element) {
        setTimeout(() => {
        element.scrollIntoView({behavior: 'smooth', block: 'start', inline:
        'nearest'});        
        }, 100 );
      }
    }, 100 );
  }

  getActiveCompanies(){
    let ob = {
      "entityName":"Mktpactivecompanies",
      "sql":`SELECT A.*
            FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECOMPANY=${this.codecompany}            
            AND A.STATUS=1
            AND A.ENVIRONMENT=1`
    }

    let self = this;
     
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
         
        if( ObjectUtil.isNotEmpty(con['SQL'])){                  

        }else{
          throw Error('Empresa não configurada!');
        }
      });
  }


  openUploadFile() {
    
    const dialogRef = this.dialog.open(ImageSelectorComponent, {
      width: '800px',
      data: {codecompany: this.codecompany, idUser: this.idUser, temporaryFiles: this.temporaryFiles, selectedImages: this.selectedImages,uploadedImageUrls: JSON.parse(JSON.stringify(this.uploadedImageUrls))}
    });
    
    dialogRef.afterClosed().subscribe(result => {
        if(result){
          
          this.temporaryFiles = result.temporaryFiles;                    
          this.selectedImages =  result.selectedImages;
          
          if( this.prevUploadedImageUrls){ //devemos limpar os valores anteriores antes de alimentar novamente para garantir que nao vai ficar lixo no json
            
            this.prevUploadedImageUrls.forEach((url, index) => {              
              let path = index === 0
                ? 'main_product_image_locator'
                : `other_product_image_locator_${index}`;
                  
                this.cleanRunTimeObjectPath(path);
              //this.onModelChange(this.category+'.'+path, null, url);
            });
          }

          this.uploadedImageUrls =  JSON.parse(JSON.stringify(result.uploadedImageUrls));

          if(result.uploadedImageUrls){                        
            
            this.prevUploadedImageUrls = JSON.parse(JSON.stringify(this.uploadedImageUrls));

            result.uploadedImageUrls.forEach((url, index) => {              
              let path = index === 0
                ? 'main_product_image_locator.media_location'
                : `other_product_image_locator_${index}.media_location`;
                    
              this.onModelChange(this.category+'.'+path, null, url);
            });
          }
        }
    });
  }

  updateColumns(newDynamicColumns: TableColumn[]): void {    
    const staticColumns = this.columns.filter(column => !column.dynamic);
  
  
    const dynamicColumnsWithFlag = newDynamicColumns.map(column => ({
      ...column,
      dynamic: true
    }));
          

    this.columns = [...dynamicColumnsWithFlag, ...staticColumns];


    this.displayedColumns = this.columns.map(c => c.columnDef);
      
   this.dataSourceVariation = [];

    this.addVariationRow();
  }

  addVariationRow(): void {
    const newRow = this.columns.reduce((acc, column) => {
      if (column.type === 'select') {
        acc[column.columnDef] = column.options[0].value; 
      } else {
        acc[column.columnDef] = ''; 
      }
      return acc;
    }, {});
    
   this.dataSourceVariation = [...this.dataSourceVariation, newRow];
  }

  deleteRow(index: number): void {
   this.dataSourceVariation.splice(index, 1);
  }

  addNew(field){
    let values = field['value'];
    let objeto = values[0];

    const newObjeto = JSON.parse(JSON.stringify(objeto));
    newObjeto.position = values.length;
    field.hasMore = true;            
    field['value'].push(newObjeto);    
    
  }

  ngAfterViewInit() {
    var columnDef:columnsDef = {
      DATATYPE:"RICHTEXT",
      COLUMNDESC:"TESTE",
      COLUMNNAME:"TESTE",
      PLACEHOLDER:"TESTE",
      IDCOLUMN:1,
      ISIDENTITY:0,
      ISREQUIRED:1,
      VISIBLE:1,
      LINE:0,
      CELL:0,
      tab:'sem tab',
      REFERENCES:[],
      VALIDATIONERROR:null
     }
     this.parameters.push(columnDef);
    
  }

  buildParametersHtml(path, key){
    

    var columnDef:columnsDef = {
      DATATYPE:"RICHTEXT",
      COLUMNDESC:this.getProp(path,'title'),
      COLUMNNAME:key,
      PLACEHOLDER:"this.getProp(path,'description')",
      IDCOLUMN:1,
      ISIDENTITY:0,
      ISREQUIRED:1,
      VISIBLE:1,
      LINE:0,
      CELL:0,
      tab:'sem tab',
      REFERENCES:[],
      VALIDATIONERROR:null
     } 

     this.parameters.push(columnDef);

     this.formGroupHtml.addControl(key, new UntypedFormControl(''));

     return this.parameters;
  }

  showAddButton(key){
    
    let prop =  this.getProp(key,'prop');
    if ( prop['type']=='array'){
      if ( prop['maxUniqueItems']!= null ){
          if ( prop['maxUniqueItems'] > 1 ){
            return true;
          }else{
            return false;
          }
      }else{
        return false;
      }
    }else{
      return false;
    }

  }

  fieldTrackList(index: number, list: any){
    return index;
  }

  isRelated(itemTab:tab,key:string){
      return itemTab.propertyNames.findIndex(d=>d==key)>-1;
  }

  
   safeStringify(obj) {
    const cache = new Set();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (cache.has(value)) {
          return; 
        }
        cache.add(value);
      }
      return value;
    });
  }

  getParentPath(path: string): string {
    const parts = path.split('.');
    parts.pop(); 
    return parts.join('.');
  }


  shouldPropertyBeArray(fullPath: string, schema: any): boolean {
    const paths = fullPath.split('.');
    let currentSchema = schema;
  
    for (const path of paths) {
      if (currentSchema.type === 'array') {
        currentSchema = currentSchema.items;
      }
  
      if (currentSchema.type === 'object' && currentSchema.properties && currentSchema.properties[path]) {
        currentSchema = currentSchema.properties[path];
      } else {
        return false;
      }
    }
  
    return currentSchema.type === 'array';
  }
  
  getPropertyType(fullPath: string, schema: any): string {
    const paths = fullPath.split('.');
    paths.shift();
    let currentSchema = schema;
  
    for (const path of paths) {
      if (currentSchema.type === 'array') {
        currentSchema = currentSchema.items;
      }
  
      if (currentSchema.type === 'object' && currentSchema.properties) {
        if (currentSchema.properties[path]) {
          currentSchema = currentSchema.properties[path];
        } else {
          return null;
        }
      } else if (currentSchema.type !== 'array') {
        return null;
      }
    }
  
    if (currentSchema.oneOf) {
      for (const option of currentSchema.oneOf) {
        if (option.format) {
          return option.format;
        }
      }
    }

    if (currentSchema.anyOf) {
      for (const option of currentSchema.anyOf) {
        if (option.format) {
          return option.format;
        }
      }
    }
  
  
    return currentSchema.type;
  }


  getPropertyTitle(property: string, schema: any, instancePath: string = ""): string {
    let currentSchema = schema;

    // Dividir o instancePath em partes
    const pathParts = instancePath.split('/').filter(part => part);

    for (let i = 0; i < pathParts.length; i++) {
        if (currentSchema.type === 'object' && currentSchema.properties[pathParts[i]]) {
            currentSchema = currentSchema.properties[pathParts[i]];
        } else if (currentSchema.type === 'array' && currentSchema.items) {
            currentSchema = currentSchema.items;
        }
    }

    if (currentSchema.properties && currentSchema.properties[property]) {
        return currentSchema.properties[property].title || null;
    }

    return null;
  }

  getDefaultValueFromRef(refPath: string, schema: any): any {
    const paths = refPath.split('/');
    let currentSchema = schema;

    for (const path of paths) {
        if (path === '#' || path === '$defs') continue;
        currentSchema = currentSchema[path];
    }

    return currentSchema.default;
  }
  

  private applyAditionalRules(path: string, newValue: any, item: any) {
    const produtctExemption = 'supplier_declared_has_product_identifier_exemption'; //ISENCAO DE EAN
    const eanPath = 'externally_assigned_product_identifier'; //ISENCAO DE EAN
    
    
    // Verifica se o campo modificado pertence ao fulfillment_availability
    if (path.includes(produtctExemption)) {
       
      if (newValue == true) {
        
        delete this.runTimeObject['externally_assigned_product_identifier'];

        if(item != null && item.value[0].externally_assigned_product_identifier){
          //console.log(item);
        }
      }              
    }else if(path.includes(eanPath)){
      
        if(this.runTimeObject['supplier_declared_has_product_identifier_exemption'] && this.runTimeObject['supplier_declared_has_product_identifier_exemption'][0].value != null && this.runTimeObject['supplier_declared_has_product_identifier_exemption'][0].value == true){
            delete this.runTimeObject['externally_assigned_product_identifier'];

            if(item != null && item.value[0] != null){
              item.value[0].value = null;
              item.value[0].type = null;
              
            }      

            throw Error('Só é possível prencher esse campo com Possui Isenção do Identificador Externo desligado');
        }

    }

  }


  private applyFulfillmentAvailabilityRules(path: string, newValue: any, item: any) {
    const fulfillmentPath = 'fulfillment_availability';
    

    // Verifica se o campo modificado pertence ao fulfillment_availability
    if (path.includes(fulfillmentPath)) {
        // Obtém o último segmento do caminho
        const segments = path.split('.');
        const lastSegment = segments[segments.length - 1];

        // Aplica as regras específicas com base no último segmento
        switch (lastSegment) {
            case 'fulfillment_channel_code':
                this.applyFulfillmentChannelCodeRule(newValue,item);
                break;
            case 'is_inventory_available':
                this.applyIsInventoryAvailableRule(newValue, item);
                break;
            case 'quantity':
                this.applyQuantityRule(newValue,item);
                break;
            case 'lead_time_to_ship_max_days':
                this.applyLeadTimeToShipMaxDaysRule(newValue, item);
                break;
            case 'restock_date':
                this.applyRestockDateRule(newValue,item);
                break;            
        }
    }
}

  
  private applyFulfillmentChannelCodeRule(newValue: any, item: any) {
      if (newValue == 'DEFAULT') {

        if(this.runTimeObject['fulfillment_availability'] && this.runTimeObject['fulfillment_availability'][0].is_inventory_available != null){ // is_inventory_available preenchido nao permite quantidade
          if(item != null && item.value[0] != null){
            item.value[0].quantity = null;
          }
          delete this.runTimeObject['fulfillment_availability'].quantity;
        }
        //console.log('NAO PODE TER QUANTITY') ;
        
        //delete this.runTimeObject.fulfillment_availability.quantity;
      }else if(newValue == 'AMAZON_NA'){        
          delete this.runTimeObject['fulfillment_availability'][0].is_inventory_available;                
          delete this.runTimeObject['fulfillment_availability'][0].lead_time_to_ship_max_days;
          delete this.runTimeObject['fulfillment_availability'][0].quantity;        
          delete this.runTimeObject['fulfillment_availability'][0].restock_date;
          
          if(item != null && item.value[0] != null){
            item.value[0].is_inventory_available = null;
            item.value[0].lead_time_to_ship_max_days = null;
            item.value[0].quantity = null;
            item.value[0].restock_date = null;
          }        
      }
  }

  
  private applyIsInventoryAvailableRule(newValue: any, item: any) {
    if(this.runTimeObject['fulfillment_availability'][0].fulfillment_channel_code != 'DEFAULT'){
      delete this.runTimeObject['fulfillment_availability'][0].is_inventory_available;          
      throw Error('Só é possível prencher esse campo com Disponibilidade de Atendimento - DEFAULT');
    }


      if (this.runTimeObject['fulfillment_availability']){           
          if(newValue == false){ //Se é falso devemos remover do JSON por problemas de validação com AJV
            delete this.runTimeObject['fulfillment_availability'][0].is_inventory_available;          

          }else{
            delete this.runTimeObject['fulfillment_availability'][0].quantity;          
              
            if(item != null && item.value[0] != null){
              item.value[0].quantity = null;              
            }
          }

          
      }
  }

  
  private applyQuantityRule(newValue: any, item: any) {
      if(this.runTimeObject['fulfillment_availability'][0].fulfillment_channel_code != 'DEFAULT'){
        delete this.runTimeObject['fulfillment_availability'][0].quantity;

        if(item != null && item.value[0] != null){          
          item.value[0].quantity = null;          
        }         

        throw Error('Só é possível prencher esse campo com Disponibilidade de Atendimento - DEFAULT');
      }

      if (this.runTimeObject['fulfillment_availability'] && this.runTimeObject['fulfillment_availability'][0].is_inventory_available != null){
    
          if(this.runTimeObject['fulfillment_availability'][0].is_inventory_available){
            delete this.runTimeObject['fulfillment_availability'][0].quantity; 
            
            if(item != null && item.value[0] != null){          
              item.value[0].quantity = null;          
            }         

            throw Error('Não é possível preencher a quantidade com o campo inventário sempre disponível LIGADO.');
          }                    
      }
  }

  
  private applyLeadTimeToShipMaxDaysRule(newValue: any, item: any) {
      if (this.runTimeObject['fulfillment_availability'] ) {


          if(this.runTimeObject['fulfillment_availability'][0].fulfillment_channel_code == 'DEFAULT'){
            if(!this.runTimeObject['fulfillment_availability'][0].is_inventory_available && !this.runTimeObject['fulfillment_availability'][0].quantity){
              delete this.runTimeObject['fulfillment_availability'][0].lead_time_to_ship_max_days;

              if(item != null && item.value[0] != null){          
                item.value[0].lead_time_to_ship_max_days = null;          
              }         

              
              throw Error('Só é possível prencher esse campo com o campo Inventario sempre disponível ligado ou Quantidade preenchido!');
            }
          }else{

            if(item != null && item.value[0] != null){          
              item.value[0].lead_time_to_ship_max_days = null;          
            }         


            delete this.runTimeObject['fulfillment_availability'][0].lead_time_to_ship_max_days;
            throw Error('Só é possível prencher esse campo com CAMPO: Disponibilidade de Atendimento - DEFAULT');
          }
       
      }
  }

  
  private applyRestockDateRule(newValue: any, item: any) {
      if (this.runTimeObject['fulfillment_availability']) {
        if(this.runTimeObject['fulfillment_availability'][0].fulfillment_channel_code == 'DEFAULT'){
          if(!this.runTimeObject['fulfillment_availability'][0].is_inventory_available && !this.runTimeObject['fulfillment_availability'][0].quantity){
            delete this.runTimeObject['fulfillment_availability'][0].restock_date;
            
            if(item != null && item.value[0] != null){          
              item.value[0].restock_date = null;          
            }         

            throw Error('Só é possível prencher esse campo com o campo Inventario sempre disponível ligado ou Quantidade preenchido!');
          }
        }else{
          delete this.runTimeObject['fulfillment_availability'][0].restock_date;

          if(item != null && item.value[0] != null){          
            item.value[0].restock_date = null;          
          }         


          throw Error('Só é possível prencher esse campo com CAMPO: Disponibilidade de Atendimento - DEFAULT');
        }
      }
  }

  onModelChange(path: string, item, newValue) {
 
    let paths = path.split('.');
    paths.shift();
  
    let obj = this.runTimeObject;
    var position = null;

    if(item && item.hasMore){
      for (const valueItem of item.value) {        
        if (valueItem.value === newValue) {
            
            if(valueItem.position){
              position = valueItem.position;            
            }                        
        }
      }
    }

    
    if(item && position){ 
      if (!obj[item.key]) {
        obj[item.key] =  [{}];
      }
      
      if(!obj[item.key][position]){
        obj = obj[item.key][position] = {};   
      }else{
        obj = obj[item.key][position];
      }
      
    }else{
      for (let i = 0; i < paths.length - 1; i++) {
        const currentPath = paths.slice(0, i + 1).join('.');
        if (this.shouldPropertyBeArray(currentPath, this.jsonSchema)) {
          if (!obj[paths[i]]) {
            obj[paths[i]] = [{}];
          }
          obj = obj[paths[i]][0]; 
        } else {
          if (!obj[paths[i]]) {
            obj[paths[i]] = {};
          }
          obj = obj[paths[i]];
        }
      }
    }

  
  
    
  
    const lastKey = paths[paths.length - 1];

    const propertyType = this.getPropertyType(path, this.jsonSchema);

  
    if (this.shouldPropertyBeArray(path, this.jsonSchema)) {
      obj[lastKey] = Array.isArray(newValue) ? newValue : [newValue];
    } else {
      obj[lastKey] = this.convertValueToType(newValue, propertyType);

    }
    

    const associatedProperties = this.getAssociatedProperties(path, this.jsonSchema);

    for (const associatedProperty of associatedProperties) {
        if (associatedProperty !== 'value' && !obj[associatedProperty]) {            
            obj[associatedProperty] = (this.jsonSchema as any).$defs && (this.jsonSchema as any).$defs[associatedProperty] && (this.jsonSchema as any).$defs[associatedProperty].default;            
        }
    }

    const rootAfterFirstPart = paths[0];


    if (!this.processedRoots.has(rootAfterFirstPart)) { //pode ser 3 4 5? complexo
        
        const rootSchema = this.jsonSchema['properties'][rootAfterFirstPart];

        if (rootSchema && rootSchema.selectors) {
            for (const selector of rootSchema.selectors) {
              
                if(Array.isArray(this.runTimeObject[rootAfterFirstPart])){
                  for(let z =0; z < this.runTimeObject[rootAfterFirstPart].length; z++){
                    if(!this.runTimeObject[rootAfterFirstPart][z][selector]){
                      this.runTimeObject[rootAfterFirstPart][z][selector] = (this.jsonSchema as any).$defs && (this.jsonSchema as any).$defs[selector] && (this.jsonSchema as any).$defs[selector].default;    
                    }
                  } 

                }else if (!this.runTimeObject[rootAfterFirstPart][selector]) {
                  this.runTimeObject[rootAfterFirstPart][selector] = (this.jsonSchema as any).$defs && (this.jsonSchema as any).$defs[selector] && (this.jsonSchema as any).$defs[selector].default;
                }
            }
        }

        this.processedRoots.add(rootAfterFirstPart);
    }

    this.applyFulfillmentAvailabilityRules(path, newValue, item);
    //this.applyAditionalRules(path, newValue, item);
    //console.log(JSON.stringify(this.runTimeObject));  

    this.formattedJson = JSON.stringify(this.runTimeObject, null, 4); 

    if(path.includes("variation_theme")){
      if(!newValue){
        this.hasVariation = false;
        
       this.dataSourceVariation = [];

        return;
      }
      this.hasVariation = true;
            

      let properties = this.jsonSchema['properties'][newValue.toLowerCase()];      
      var colunas:TableColumn[] = [];
      let options = [];
      let optionsName = [];

      //codigo abaixo ainda precisa ser melhorado para quebrar em métodos a parte repetida
      if(!properties && newValue.includes("/")){        
        var arrVariation = newValue.split("/");
       
        for(var variationName of arrVariation){            
            properties = this.jsonSchema['properties'][variationName.toLowerCase()];

            if(properties){
           
              let type =  properties.items["type"] == "object" ?  'text' : properties.items["type"]; // pode ter o tipo array?

              if(properties.items["properties"]["value"]["anyOf"]){

                for ( var element of properties.items["properties"]["value"]["anyOf"]){
                  if ( element.enum !=null){                  
                    options = element.enum;                                        
                  }

                  if(element.enumNames){
                    optionsName = element.enumNames;                                        
                  }
                };

                type = "selectComplete";

              }

              if(type == "selectComplete"){
                colunas.push({ columnDef: variationName, header: properties.title, type: type,  dynamic: true, optionsIndex: options, optionsName: optionsName },);
              }else{
                colunas.push({ columnDef: variationName, header: properties.title, type: type,  dynamic: true },);
              }

            }

        }      

      }else if(properties){
        let type =  properties.items["type"] == "object" ?  'text' : properties.items["type"]; // pode ter o tipo array?

        if(properties.items["properties"]["value"]["anyOf"]){

          for ( var element of properties.items["properties"]["value"]["anyOf"]){
            if ( element.enum !=null){                  
              options = element.enum;                                        
            }

            if(element.enumNames){
              optionsName = element.enumNames;                                        
            }
          };

          type = "selectComplete";

        }

        if(type == "selectComplete"){
          colunas.push({ columnDef: newValue.toLowerCase(), header: properties.title, type: type,  dynamic: true, optionsIndex: options, optionsName: optionsName },);
        }else{
          colunas.push({ columnDef: newValue.toLowerCase(), header: properties.title, type: type,  dynamic: true },);
        }

        
      }
      

      if(colunas.length > 0){
        this.updateColumns(colunas);
      }
    }
  }

  checkVariation(path: string, newValue: string): void {
    if (path.includes("variation_theme")) {
      this.hasVariation = !!newValue;
  
      if (!newValue) {
       this.dataSourceVariation = [];
      }
    }
  }

  copyFormattedJsonToClipboard() {
    const textarea = document.createElement('textarea');
    textarea.value = this.formattedJson;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    
    alert('JSON copiado para a área de transferência!');
  }
 

  getAssociatedProperties(fullPath: string, schema: any): string[] {
    const paths = fullPath.split('.');
    paths.shift();

    let currentSchema = schema;

    // Histórico de hierarquia navegada
    let hierarchy: { path: string, schema: any }[] = [];

    for (let i = 0; i < paths.length; i++) {
        const path = paths[i];



        if (currentSchema.type === 'array') {
            currentSchema = currentSchema.items;
        }

        if (currentSchema.type === 'object' && currentSchema.properties) {
            if (currentSchema.properties[path]) {
                currentSchema = currentSchema.properties[path];
                // Adiciona o caminho e o esquema atual à hierarquia
                hierarchy.push({ path, schema: currentSchema });
            } else {
                return [];
            }
        } else if (currentSchema.type !== 'array') {
            return [];
        }

        // Se o último elemento da path é 'value', devemos retornar as propriedades associadas do nível anterior
        if (i === paths.length - 1 &&  i > 0) {
            const parentSchema = hierarchy[hierarchy.length - 2].schema;
          // const parentPath = hierarchy[hierarchy.length - 2].path; nao utilizado por eqto

            if (parentSchema && parentSchema.selectors) {
                return parentSchema.selectors;
            } else if(parentSchema.properties  && parentSchema.required){
              return parentSchema.required;
            }else {
                return [];
            }
        }
    }

    return currentSchema.selectors || [];
  }


  getDateFormatForPath(fullPath: string, schema: any): string {
    const paths = fullPath.split('.');
    let currentSchema = schema;
  
    for (const path of paths) {
      if (currentSchema.type === 'array') {
        currentSchema = currentSchema.items;
      }
  
      if (currentSchema.type === 'object' && currentSchema.properties) {
        if (currentSchema.properties[path]) {
          currentSchema = currentSchema.properties[path];
        } else {
          return null;
        }
      } else if (currentSchema.type !== 'array') {
        return null;
      }
    }
  
    if (currentSchema.oneOf) {
      for (const option of currentSchema.oneOf) {
        if (option.format) {
          return option.format;
        }
      }
    }

    if (currentSchema.anyOf) {
      for (const option of currentSchema.anyOf) {
        if (option.format) {
          return option.format;
        }
      }
    }
  
    return null;
  }


  isValidJson(userAction:boolean) {
    //console.log(this.jsonSchema);    

    this.jsonValidatorIsCalled = true;

    const validate = this.compileAjv.compile(this.jsonSchema);
    const valid = validate(this.runTimeObject);

    
    this.updateAmazonVars();

    if (!valid) {
      //console.log(validate.errors);

    /*  for (const error of validate.errors) {
        let propertyToRemove = this.findInvalidPropertyFromError(error, this.jsonSchema);  
        if(propertyToRemove){
          this.removePropertyFromRuntimeObject(error.instancePath, propertyToRemove);
        }      
      }*/

      errorsByTab  = {};

      if(userAction){        
    
        for (const error of validate.errors) {
          const errorMessageResult = this.getFriendlyErrorMessage(error);
          if (errorMessageResult.tab) {
            if (!errorsByTab[errorMessageResult.tab]) {
              errorsByTab[errorMessageResult.tab] = [];
            }
            errorsByTab[errorMessageResult.tab].push(errorMessageResult.message);
          } else {          
            if (!errorsByTab['General']) {
              errorsByTab['General'] = [];
            }
            errorsByTab['General'].push(errorMessageResult.message);
          }
        }

        this.listaDeErros = [];
        for (const [tab, messages] of Object.entries(errorsByTab)) {
          this.listaDeErros.push(this.sanitizer.bypassSecurityTrustHtml(`<div style='margin-bottom: 10px;margin-top: 10px'><b>Erros na aba ${tab}:</b></div>`));
          this.listaDeErros.push(...messages);
        }

        this.listaDeErrosDef = validate.errors;
      //  this.listaDeErros = validate.errors.map(this.getFriendlyErrorMessage.bind(this));

        this.validateImages();
      }

      
      
      this.missingFields = validate.errors.map(error => error.params.missingProperty);
      this.missingFields = this.missingFields.filter(field => field !== undefined);

      this.erroValidacao = true;

  

      this.addMissingFields(userAction);
    } else {

      this.erroValidacao = false;
      this.listaDeErros = [];

     // this.validateImages();
    }

   
  }


  validateImages() {
    if (this.uploadedImageUrls == null || this.uploadedImageUrls.length == 0) {
      this.listaDeErros.push(this.sanitizer.bypassSecurityTrustHtml(`<div style='margin-bottom: 10px;margin-top: 10px'><b>Erros na aba Finalizar e Validar</b></div>`));
      this.listaDeErros.push("É necessário adicionar no mínimo uma Imagem para fazer o envio da Oferta! \n Utilize o botão <b>'Enviar Imagens'</b> ");
      this.erroValidacao = true;
    }
  }

  removeInvalidProperty(error): void {
    if (error.message !== 'must NOT be valid') return;

    const properties = error.instancePath.split('/').filter(p => p);
    let targetObj = this.runTimeObject;
    let indexInArray = -1;

    for (let i = 0; i < properties.length - 1; i++) {
        if (!isNaN(Number(properties[i]))) {
            // Se for um número, estamos lidando com um índice de array
            indexInArray = Number(properties[i]);
            continue; 
        }
        if (indexInArray > -1) {
        
            targetObj = targetObj[properties[i - 1]][indexInArray];
            indexInArray = -1;
        } else {
            targetObj = targetObj[properties[i]];
        }
    }

    const lastProperty = properties[properties.length - 1];
    if (targetObj && targetObj.hasOwnProperty(lastProperty)) {
        delete targetObj[lastProperty];
    }
}

findInvalidPropertyFromError(error, schema): string {
  if (error.message !== 'must NOT be valid') return;
  
  const pathParts = error.schemaPath.split('/').slice(1); // remove o '#' no começo

  let currentSchemaPart = schema;


  for (let i = 0; i < pathParts.length - 1; i++) { // -1 porque não precisamos da última parte (then/not)
      const part = pathParts[i];

      
      if (Number.isInteger(+part)) {
          currentSchemaPart = currentSchemaPart[+part];
      } else {
          currentSchemaPart = currentSchemaPart[part];
      }
  }


  if (currentSchemaPart  && currentSchemaPart.not && currentSchemaPart.not.required) {
      return currentSchemaPart.not.required[0];
  }

  return null;
}

removePropertyFromRuntimeObject(instancePath: string, propertyToRemove: string) {  
    const pathParts = instancePath.split('/').filter(part => part); 

    let targetObj = this.runTimeObject;

    for (let i = 0; i < pathParts.length; i++) {
        const part = pathParts[i];

        
        if (Number.isInteger(+part)) {
            targetObj = targetObj[+part];
        } else {
            targetObj = targetObj[part];
        }
    }

  // Remover a propriedade
    delete targetObj[propertyToRemove];
  }

  getDetailedErrorMessageForLogicalSchema(error, schema): string {
  const pathParts = error.schemaPath.split('/').slice(1); // remove o '#' no começo

  let currentSchemaPart = schema;

 
  for (let i = 0; i < pathParts.length; i++) {
      const part = pathParts[i];

      if (Number.isInteger(+part)) {
          currentSchemaPart = currentSchemaPart[+part];
      } else {
              currentSchemaPart = currentSchemaPart[part];
          
      }
  }

  
  if (currentSchemaPart) {
      
      if (currentSchemaPart.not && currentSchemaPart.not.required) {
          return currentSchemaPart.not.required[0];
      }

      if (currentSchemaPart.then && currentSchemaPart.then.required) {
          return currentSchemaPart.then.required[0];
      }

      if(currentSchemaPart.required){
        return currentSchemaPart.required[0];
      }


  }

  return null;
}



  getFriendlyErrorMessage(error): ErrorMessageResult  {
    let fieldName = this.transformPathToFieldName(error.instancePath, error.params.missingProperty);
    let correspondingTabKey = null;

    if(error.params.missingProperty){
      
        
      Object.keys(this.propertyGroups).forEach(key => {
        if (this.propertyGroups[key]['propertyNames'].includes(error.params.missingProperty)) {
          correspondingTabKey = key;
        }
      });

      let propertyToFind = error.params.missingProperty == 'value'? fieldName : error.params.missingProperty;
      let title = this.getPropertyTitle(propertyToFind, this.jsonSchema,error.instancePath);

      fieldName = title ? title : this.capitalizeFirstLetter(error.params.missingProperty.replace(/_/g, ' '));
    }else if(error.message == 'must NOT be valid' && (error.keyword == 'if' || error.keyword ==  'then'|| error.keyword ==  'not')){
      fieldName =  this.getDetailedErrorMessageForLogicalSchema(error, this.jsonSchema);
    }

    if(correspondingTabKey){
      this.cd.detectChanges();
      const aba = this.tabs.find(tab => tab.name === correspondingTabKey);

      if(aba){
        correspondingTabKey = aba.title;
      }
      
    }

    

    let message: string;
    switch (error.keyword) {
      case 'anyOf':
      case 'oneOf':
        message = `<b>${fieldName}</b> tem um valor inválido.`;
        break;
      case 'not':
        message = `<b>${fieldName}</b> não deve ser válido.`;
        break;
      case 'if':
        message = `<b>${fieldName}</b> deve corresponder ao esquema especificado.`;
        break;
      case 'required':
        message = `O campo <b>'${fieldName}'</b> é obrigatório.`;
        break;
      default:
        message = `${fieldName} é inválido.`;
    }
  
    return {
      message: message,
      tab: correspondingTabKey || null
    };
  }
  
  

  transformPathToFieldName(path: string, missingProperty?: string): string {    
    if (!path && missingProperty) {
        return this.capitalizeFirstLetter(missingProperty.replace(/_/g, ' '));
    }
    
    const parts = path.split('/').filter(part => isNaN(Number(part)) && part);
    return parts.map(part => this.capitalizeFirstLetter(part)).join(' - ');
  }

  capitalizeFirstLetter(string: string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
  }

  autoCorrectJson(): void {
    // Processar cada erro e corrigir
    for (const error of this.listaDeErrosDef) {
      let propertyToRemove = this.findInvalidPropertyFromError(error, this.jsonSchema);  
      if(propertyToRemove){
        this.removePropertyFromRuntimeObject(error.instancePath, propertyToRemove);
      }   
    }
      
      this.isValidJson(true);

      if (!this.erroValidacao) { //depois vou trocar esses alertas por mensagens do nosso componente
          alert('O JSON foi corrigido com sucesso!');
      } else {
          alert('Alguns erros não puderam ser corrigidos automaticamente. Por favor, verifique.');
      }
  }
  
  private cleanRunTimeObjectPath(path: string) {    
            
    if(this.runTimeObject[path]){
      delete this.runTimeObject[path];
    }    
    
  }
  
  /*cleanRunTimeObject(runTimeObject: any[], props: any[]) {
    
    const propLookup = {};

    for (const prop of props) {
      const shiftedId = prop.id.split('.').slice(1).join('.'); 
      propLookup[shiftedId] = prop.prop;
    }
    
    function recursiveClean(obj: any, path: string) {
      if (Array.isArray(obj)) {
        for (const item of obj) {
          recursiveClean(item, path);
        }
      } else {
        for (const key in obj) {
          const currentPath = path ? `${path}.${key}` : key;
          if (!propLookup[currentPath]) {
            
            delete obj[key];
          } else {
            
            if (typeof obj[key] === 'object' && obj[key] !== null) {
              recursiveClean(obj[key], currentPath);
            }
          }
        }
      }
    }
  
    
    for (const item of runTimeObject) {
      recursiveClean(item, '');
    }
  }*/

  convertValueToType(value: any, type: string): any {
    switch (type) {
      case 'array': //Precisamos ver o compoinente, como retornaria aqui, casos de propriedades com ARRAY deveria ser um combo de multipla seleção
        if (Array.isArray(value)) {
          return value;
        } else if (typeof value === 'string') {
          return value.split(',').map(item => item.trim());
        } else {
          return [value];
        }
      case 'integer':
        return Number(value);
      case 'number':
        return Number(value);
      case 'string':
        return String(value);
      case 'boolean':
        return value === 'true' || value === true;
      case 'date':
        return value.format('YYYY-MM-DD');
      case 'date-time':
        return value.format('YYYY-MM-DD HH:mm');
      default:
        return value;
    }
  }

  transformValue(fields){
      let array  = [];
      Object.keys(fields).forEach(a=>{
          let ob ={
            key:a,
            value:fields[a]
          }
          array.push(ob);
      })
      return array;
  }

  updateProperties(properties: any): void {
    for (const key in properties) {
      const property = properties[key];
  
      
      if (property.oneOf && Array.isArray(property.oneOf)) {
        let containsDateOrDateTime = false;
        for (const option of property.oneOf) {
          if (option.type === "string" && (option.format === "date" || option.format === "date-time")) {
            containsDateOrDateTime = true;
            break;
          }
        }
        if (containsDateOrDateTime) {
          property.anyOf = property.oneOf;
          delete property.oneOf;
        }
      }
        
      if (property.properties) {
        this.updateProperties(property.properties);
      }
      if (property.items && property.items.properties) {
        this.updateProperties(property.items.properties);
      }
    }
  }
  
  updateSchema(schema: any): void {
    this.updateProperties(schema.properties);
  }
  
  
  
  
  getProp(key,field, item?){
    
    let p = this.prop.find(d=>d.id==key) ;
    

 /*   if(field == 'columnDef'){

      let paths = key.split('.');
    
      let fieldName = paths[paths.length -1];

      if (!this.subscribedFieldNames.has(fieldName)) {        
        this.formGroupHtml.get(fieldName).valueChanges.subscribe(newValue => {
            this.onModelChange(this.category + "." + fieldName + ".value", item, newValue);
        });
        this.subscribedFieldNames.add(fieldName);
    } Futuramente será utilizado para multiploos campos HTML    
    
    }*/
    

    //console.log(p);
    
    if ( p != null && p.prop){
      p = (p as any).prop;

      let depracatedEnums = [];

      if((p as any).$lifecycle){
        depracatedEnums =(p as any).$lifecycle.enumDeprecated || [];        
      }

      if ( p['$ref'] != null){
        if ( field == 'visible'){
          return true;
        }
        if ( field=='editable'){
          return false;
        }
      }
      if ( field=='type'){
        if ( p['type']=='string' && p['enum']!=null){           

            return 'enum';
        }else{
          if ( (p['type']=='string' && p['oneOf']!=null || p['format']=='date' || p['format']=='date-time')){
            return 'datetime';
          }else{
             if ( p['type']=='array' && p['items']!=null){
                if ( p['items']['anyOf'] && (p['items']['anyOf'][0]['format']=='date' || p['items']['anyOf'][0]['format']=='date-time')){
                  return 'datetime';
                }else if(p['items']['anyOf']){
                  return 'autocomplete';
                }else{
                  return p['type'] 
                }
             }else{
                if ( p['type']=='string' && p['anyOf']!=null && p['anyOf'][0] && (p['anyOf'][0]['format']=='date' || p['anyOf'][0]['format']=='date-time')){
                  return 'datetime';
                }else if ( p['type']=='string' && p['anyOf']!=null){
                  return 'autocomplete';
                }else{
                  return p['type'];
                }
              }
             
          }
          
        }
      }
      if ( field=='min'){
        return p['minimum'];
      }

      if ( field=='max'){
        return p['maximum'];
      }

      if ( field=='prop'){
        return p;
      }

      if ( field=='enum2'){      
        return  p['anyOf']['enum'];
      

       // return p['anyOf']['enum'];
      }

      if ( field=='anyOfEnum'){
        if ( p['items']){
          if ( p['items']['anyOf']){
            for ( var element of p['items']['anyOf']){
                if ( element.enum !=null){
                  let enumRet =  element.enum;

                  const filteredEnumNames = enumRet.filter(name => !depracatedEnums.includes(name) && !name.includes('Deprecated'));


                  return filteredEnumNames;
                }
            };
          }
          return [];
        }

        if ( p['anyOf']){
          if ( p['anyOf']){
            for ( var element of p['anyOf']){
                if ( element.enum !=null){
                  

                  return element.enum;
                }
            };
          }
          return [];
        }
      }

      if ( field=='anyOfEnumNames'){
        if ( p['items']){
          if ( p['items']['anyOf']){
              

            for ( var element of p['items']['anyOf']){
                if ( element.enumNames !=null){                  
                  return element.enumNames;
                }
            };
          }
          return [];
        }

        if ( p['anyOf']){
          if ( p['anyOf']){
                   
            for ( var element of p['anyOf']){
                if ( element.enumNames !=null){               


                    return element.enumNames;
                }
            };
          }
          return [];
        }
        
        return [];
      }

      if ( field == 'anyOfeditable'){
        return true; //item nao tratado
      }

      if ( field == 'anyOfmaxLength'){
        return '10000'; //item nao tratado
      }

      if ( field == 'anyOfminLength'){
        return '0'; //item nao tratado
      }

      if(field == "enum" && key.includes("variation")){
        let enumValues = this.prop.find(d=>d.id==key).prop[field];
                        
        const filteredEnum = enumValues.filter(name => !depracatedEnums.includes(name));
        
        return filteredEnum;
      }

      if(field == "enumNames" && key.includes("variation")){
        let enumValues = this.prop.find(d=>d.id==key).prop[field];
                        

        const filteredEnum = enumValues.filter(name => !depracatedEnums.includes(name));        

        return filteredEnum;
      }

      

      return this.prop.find(d=>d.id==key).prop[field];
    }else{
      
    }
  }

  
  async ngOnInit(): Promise<void> {
      this.spinnerServices.show("amazonschema");
	  	this.row = {}
      this.canConfig = true;
      
      this.form = this.data.formGroup;
      this.category = this.form.get('OPTIONDATA').value.toLowerCase();  
      
      this.updateAmazonVars(); 


      /*Blooco abaixo para base de teste
        this.category = "tools";

      // this.jsonSchema = jsonschema as Object; usado para teste
     // this.jsonConf = jsonconf as Object; usado para teste

      this.updateAmazonVars(); //Voltar a versao original depois de testar

      addFormats(this.compileAjv,  { formats: ["date"] });
      this.idUser = this.uas.user.iduser;
      this.initialize();
      this.addVariationRow(); //SE TEM VARIACAO DEVEMOS CHAMAR ESSE CARA

      setTimeout(() => {
        this.stepper.selectedIndex = this.currentStepIndex;
        this.isValidJson(false);
        this.spinnerServices.hide("amazonschema");
        this.screenIsReady = true;
      },100);

     //Bloco termina aqui*/

      await this.getSchemas().then(async (data:string)=>{
        
          this.jsonConf = JSON.parse(JSON.stringify(data));
          let resource  = this.jsonConf['schema']['link']['resource'];
        
          await this.amazonServices.getContent(resource).then((val:string)=>{
              //console.log(val);
              if (val == null ){
                throw Error('Problema ao buscar schema da categoria.');
              }
              this.jsonSchema = JSON.parse(JSON.stringify(val));

              addFormats(this.compileAjv,  { formats: ["date"] });
              
              //this.stepper.selectedIndex = this.currentStepIndex;
              
              this.idUser = this.uas.user.iduser;

              if  ( this.uas.user.companylist.length > 1 ){ 
                this.codecompany = null;
                this.codecontract = null;
              }else{
                this.codecompany = Number(this.uas.user.companylist[0].codecompany);
                this.codecontract = Number(this.uas.user.companylist[0].codecontract)              
              }
          
              this.initialize();
              this.addVariationRow(); //SE TEM VARIACAO DEVEMOS CHAMAR ESSE CARA

              setTimeout(() => {
                this.stepper.selectedIndex = this.currentStepIndex;
                this.isValidJson(false);
                this.spinnerServices.hide("amazonschema");
                this.screenIsReady = true;
              },100);
          });
      });


      
  }

  private updateAmazonVars() {
    this.codecompany = this.form.get('CODECOMPANY').value;
    this.codecontract = this.form.get('CODECONTRACT').value;
    this.brownserNodeId = this.form.get('BROWNSENODEID').value;
    this.codeProduct = this.form.get('CODEPRODUCT').value; 
    
   /* this.codecompany = 101;bloco usado para teste
    this.codecontract = 2;
    this.brownserNodeId = "99999";
    this.codeProduct = 99999;*/
  }

  addMissingFields(userAction) {
    this.missingFields.forEach(field => {
      let correspondingTabKey = null;
        
      Object.keys(this.propertyGroups).forEach(key => {
        if (this.propertyGroups[key]['propertyNames'].includes(field)) {
          correspondingTabKey = key;
        }
      });
  
      if (correspondingTabKey) {
        
        const correspondingTab = this.tabs.find(tab => tab.name === correspondingTabKey);

        if (correspondingTab) {
          correspondingTab.propertyNames.push(field);
        } else {   
          
            const newTab = this.createNewTab(correspondingTabKey);
            this.tabs.push(newTab);
            this.cd.detectChanges();

            if(userAction){
              this.currentStepIndex = this.tabs.length;
            }
                        
          
          
        }
      } else {        
        console.log(`Campo ${field} não encontrado em nenhum grupo de propriedades.`);
      }
  
      //let isRequired = this.requiredProperties.includes(field);

      let properties = this.jsonSchema['properties'][field];
      
      if(properties){        
        let path = this.category + '.' + field;
        this.prop.push({ id: path, prop: properties });
        
        if (properties['type'] === 'array') {
          this.attributes['attributes'][field] = this.createArray(properties['items'], path);
        }
      }
      
    });
  }
    
  findCorrespondingTab(field: string) {
    return this.tabs.find(tab => tab.propertyNames.includes(field));
  }
  
  
  createAttribute(field: string, properties: any) {
    let isRequired = this.requiredProperties.includes(field);
    if (properties['type'] === 'array' && isRequired) {
      let path = this.category + '.' + field;
      this.prop.push({ id: path, prop: properties });
      return this.createArray(properties['items'], path);
    }  
    return null;
  }
  
  
  createNewTab(tabKey: string) {
    const groupInfo = this.propertyGroups[tabKey];
    if (groupInfo) {
      return {
        name: tabKey,
        title: groupInfo['title'],
        description: groupInfo['description'],
        propertyNames: groupInfo['propertyNames']
      };
    } else {
      console.error(`Informações do grupo para ${tabKey} não encontradas.`);
      return null;
    }
  }
  
   getMockSchemaConfiguration(): any {
    return {
      requiredFields: ["variation_theme", "supplier_declared_has_product_identifier_exemption"],
      htmlFields: ["product_description"],
      tabs: [
        {
          name: "product_identity",
          title: "Product Identity",          
          fieldOrder: ["item_name"]
        }      
      ],
      tabOrder: ["product_identity","product_details"]  
    };
  }

  initialize(){        

    this.requiredProperties = ObjectUtil.FindObject(this.jsonSchema, '$.required')[0];
    this.propertyGroups = ObjectUtil.FindObject( this.jsonConf , '$.propertyGroups')[0];  
    this.additionalConfig = this.getMockSchemaConfiguration();

    let attribs = {};
    
    Object.keys(this.propertyGroups).forEach(key=>{
        let tab = key;

        let propertyNamesTab = this.propertyGroups[key]['propertyNames'];

        
        let hasRequiredProperty = propertyNamesTab.some(prop => {
          if (this.requiredProperties.includes(prop)) {
            return true;
          }

          if (this.additionalConfig && this.additionalConfig.requiredFields && this.additionalConfig.requiredFields.includes(prop)) {
            return true;
          }

          return false;
        });

        

        if(hasRequiredProperty){
      
          this.tabs.push({
                name:tab,
                title:this.propertyGroups[key]['title'],
                description:this.propertyGroups[key]['description'],
                propertyNames:this.propertyGroups[key]['propertyNames']
          });

          

          let propertyNames:string[] = this.propertyGroups[key]['propertyNames'];

          if(this.additionalConfig && this.additionalConfig.tabs){
            let tabConfig = this.additionalConfig.tabs.find(tabConfig => tabConfig.name === tab);
  
            let fieldOrderForTab = tabConfig?.fieldOrder;
    
            if(fieldOrderForTab){
              // Ordenar os campos de acordo com fieldOrder
              propertyNames.sort((a, b) => {
                const indexA = fieldOrderForTab.indexOf(a);
                const indexB = fieldOrderForTab.indexOf(b);
    
                return indexA - indexB;
              });
            }
          }


          propertyNames.forEach(prop=>{
              
              let isRequired = this.requiredProperties.findIndex(d=>d==prop)>-1;

              if (this.additionalConfig && this.additionalConfig.requiredFields && this.additionalConfig.requiredFields.includes(prop)) {
                isRequired = true;
              }

              var propriedades = this.jsonSchema['properties'][prop];

             
              
              
              
              if ( propriedades['type']=='array' && isRequired){
                //console.log(prop);

                let path = this.category+'.'+prop;
                this.prop.push({id:path,prop:propriedades});

                if(this.additionalConfig && this.additionalConfig.htmlFields && this.additionalConfig.htmlFields.includes(prop)){
                  propriedades['items']['properties'].html = true;
              }
                
                attribs[prop]= this.createArray(propriedades['items'],path);  
              //  delete propriedades['items'];
              }
          });
      }
    });

    this.tabs.sort((a, b) => {
      if (this.additionalConfig && this.additionalConfig.tabOrder) {
        const indexA = this.additionalConfig.tabOrder.indexOf(a.name);
        const indexB = this.additionalConfig.tabOrder.indexOf(b.name);
        
        
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        
        
        if (indexA !== -1) {
          return -1;
        }
        
        if (indexB !== -1) {
          return 1;
        }
      }
          
      return 0;
    });

  

    this.moveField("variation_theme", "variations", "product_identity");
    
    this.attributes['productType']=this.category;
    this.attributes['requirements']="LISTING";
    this.attributes['attributes']=attribs;
    
    if(this.brownserNodeId){
      this.onModelChange(this.category+".recommended_browse_nodes.value", null, this.brownserNodeId);
    }
    
    try {        

      this.compileAjv.addSchema(this.jsonSchema, this.jsonSchema['$schema']);
      
    } catch (error) {
      
    }


    //feito para trocar o oneOf para anyOf em caso das datas para evitar problemas de validação.
    this.updateSchema(this.jsonSchema);

}
  moveField(fieldName, fromTabName, toTabName) {
    
    const fromTabIndex = this.tabs.findIndex(tab => tab.name === fromTabName);

    const fromTab = this.tabs.find(tab => tab.name === fromTabName);

    
    const toTab = this.tabs.find(tab => tab.name === toTabName);
  
    if (fromTab && toTab) {
    
      fromTab.propertyNames = fromTab.propertyNames.filter(name => name !== fieldName);
  
    
      toTab.propertyNames.push(fieldName);  


      this.requiredProperties = ObjectUtil.FindObject(this.jsonSchema, '$.required')[0];      

      let hasRequiredProperty = fromTab.propertyNames.some(prop => {
        if (this.requiredProperties.includes(prop)) {
          return true;
        }

        return false;
      });

      if(!hasRequiredProperty || fromTab.propertyNames.length === 0) {
        this.tabs.splice(fromTabIndex, 1);            
      }
      
    } else {
      console.log("Tab de origem ou destino não encontrada");
    }
  }

  saveProduct(){
    this.updateAmazonVars();
      
    this.codeProduct = this.form.get('CODEPRODUCT').value;

    if(this.form.get('IDSELLER') && this.form.get('IDSELLER').value && this.codeProduct){                

        return this.amazonServices.saveProduct(this.form.get('OPTIONDATA').value, this.form.get('CODECONTRACT').value, this.form.get('IDSELLER').value, this.form.get('CODECOMPANY').value, this.brownserNodeId, this.codeProduct, this.runTimeObject, this.hasVariation? this.dataSourceVariation : null);
      }else{
        throw Error('É necessário salvar o produto no formulário principal !');
      }
  }

  callAmazonPut(){
    return this.amazonServices.callAmazonItemPut(this.runTimeObject);
  }

  async getSchemas() {
    return await this.amazonServices.getSchema(this.category.toUpperCase(),this.codecompany);
  }

  createArray(items,path){
      let array = [];
      
      if ( items['type'] == 'object'){
          let ob = this.createObject(items['properties'],path);
          array.push(ob);
      }
      if ( items['type'] == 'string'){
          let ob = '';
          array.push(ob);
      }
      return array;
  }

  transformObject(field){
      let ob = {}
      ob['key'] = field.key;
      ob['value'] = [field.value];
      
      return ob;
  }

  

  createObject(properties,path){
    let ob = {};

    if(path.includes('recommended_browse_nodes')){
      properties.value.hidden = true;
    }

    let paths = path.split('.');

    

    if(properties.html){
      properties.value.html = true;

      let fieldName = paths[paths.length -1];

      var columnDef:columnsDef = {
        DATATYPE:"RICHTEXT",
        COLUMNDESC:properties.value.description,
        COLUMNNAME:fieldName,
        PLACEHOLDER:properties.value.description,
        IDCOLUMN:1,
        ISIDENTITY:0,
        ISREQUIRED:1,
        VISIBLE:1,
        LINE:0,
        CELL:0,
        tab:'sem tab',
        REFERENCES:[],
        VALIDATIONERROR:null
       } 

       properties.value.columnDef = columnDef;
  
       this.parameters.push(columnDef);
  
      this.formGroupHtml.addControl(fieldName, new UntypedFormControl(''));

      this.formGroupHtml.get(fieldName).valueChanges.subscribe(newValue => {        
        this.onModelChange(this.category+"."+fieldName+".value", null, newValue);       
      });         
    }
    
  
    Object.keys(properties).forEach(prop=>{
        let value = properties[prop];
        if ( value['$ref']!=null){
            ob[prop]=this.getReference(value);
            let newPath = path+"."+prop;
            this.prop.push({id:newPath,prop:value});
        }else{
            let type = properties[prop]['type']; 
            let enumV = properties[prop]['enum'];
            
            if ( type == 'string'&& enumV== null  ){
              ob[prop]='';
              let newPath = path+"."+prop;

            
              this.prop.push({id:newPath,prop:value});
            }
            if ( type == 'string' && enumV!= null){
              ob[prop]=''; //criarEnum
              let newPath = path+"."+prop;
              this.prop.push({id:newPath,prop:value});
              //this.onModelChange(newPath, null, ob[prop]); 
            }
            if ( type == 'boolean' ){
              ob[prop]=false; //criarEnum
              let newPath = path+"."+prop;
              this.prop.push({id:newPath,prop:value});

              if(!path.includes('fulfillment_availability')){
                this.onModelChange(newPath, null, ob[prop]); 
              }
              
            }
            if ( type == 'object' ){
              if ( value['properties']!=null ){
                let newPath = path+"."+prop;
                this.prop.push({id:newPath,prop:value});
                ob[prop]=this.createObject(value['properties'],newPath);
              }
            }
            if ( type == 'array' ){
              let newPath = path+"."+prop;

              

              this.prop.push({id:newPath,prop:value});
              ob[prop]=this.createArray(value['items'],newPath);
            }
            if ( type == 'number' ){
              ob[prop]=Number(0.0);
              let newPath = path+"."+prop;
              this.prop.push({id:newPath,prop:value});
              if(!path.includes('fulfillment_availability')){
                this.onModelChange(newPath, 0, ob[prop]); 
              }              
            }
            if ( type == 'integer' ){
              ob[prop]= 0;
              let newPath = path+"."+prop;
              this.prop.push({id:newPath,prop:value});
              if(!path.includes('fulfillment_availability')){
                this.onModelChange(newPath, 0, ob[prop]); 
              }
            }
        }
    })
    return ob;
  }

  createaValidationError(prop:Properties){
      let validation = {
          type:'select',
          options:[]
      }
      
      for ( var i = 0; i < prop.enum.length; i++){
          validation.options.push({
              view: prop.enumNames[i],
              value: String(prop.enum[i])
          });
      }
      
      
      return JSON.stringify(validation);
  }

  createaValidationValueInteger(prop:Properties){
    let validation = {
        type:'validationInteger',
        options:{}
    }
    
    validation.options['minimum'] = prop['minimum'];
    validation.options['maximum'] = prop['maximum'];
      
    return JSON.stringify(validation);
}

  mountConfig(key:string, obj:any){
    let config:columnsDef = null;
  
    if(key != null && obj != null){      

      config  = {
        IDCOLUMN: Number(1),
        COLUMNNAME: key,
        COLUMNDESC: obj.header,
        ISREQUIRED: 0,
        ISREADONLY: 0, //isRef? 1 : prop.editable ? 0 : 1,
        DATATYPE: obj.type,
        PLACEHOLDER: null,
        tab: 'Geral',
        ISIDENTITY:0,
        VISIBLE: 1,
        NOSHOW: null,
        LINE:0,
        CELL:0,
        COLSIZE:  50,
        visible: true,
        ISFK: 0,
        ISNULLABLE: 1
      }

    }else{

      let prop = this.prop.find(d=>d.id==key).prop ;

      config  = {
        IDCOLUMN: Number(1),
        COLUMNNAME: key,
        COLUMNDESC: prop['title'],
        ISREQUIRED: 0,
        ISREADONLY: 0, //isRef? 1 : prop.editable ? 0 : 1,
        DATATYPE: prop['type'],
        PLACEHOLDER: prop['example']!= null ? prop['examples'].join(',') : null,
        tab: 'Geral',
        ISIDENTITY:0,
        VISIBLE: 1,
        NOSHOW: null,
        LINE:0,
        CELL:0,
        COLSIZE:  prop['maxLength'] == null ? prop['size']:prop['maxLength'],
        visible: true,
        ISFK: 0,
        ISNULLABLE: 1
      }

    }
    return config;
  }

    getReference(prop):string{
      let referencia = prop['$ref'];
      referencia = referencia.replace('#/$defs/','');
      let refSchema = this.jsonSchema['$defs'][referencia];
      return refSchema['default'];

    }
}
